<template>
    <div class="filter-sort">
             <div class="filter-sort-box">
                    <div class="sort-box" v-if="rowParams.isShowSort">
                      <span class="sort-icon">
                        <i class="sort-caret ascending" :class="{'ascActive':filterParams.activeSort.dataType==rowParams.key&&filterParams.activeSort.sortType=='asc'}" @click="sort(rowParams.key,filterParams.activeSort.sortType=='asc'?'':'asc')"></i>
                        <i class="sort-caret descending" :class="{'descActive':filterParams.activeSort.dataType==rowParams.key&&filterParams.activeSort.sortType=='desc'}" @click="sort(rowParams.key,filterParams.activeSort.sortType=='desc'?'':'desc')"></i>
                      </span>
                    </div>
                    <div class="filter-box" v-if="rowParams.isShowFilter">
                      <el-popover
                          @after-leave="onHide"
                          placement="bottom"
                          ref="popover"
                          width="207"
                          :trigger="rowParams.trigger || 'hover'"
                          popper-class="my-popover"
                          v-model="visible"
                        >
                        <div v-if="rowParams.input=='sectionText'" class="filter-content">
                            <!-- 区间输入框开始 -->
                            <div class="filter-num filter-serachTnput">
                              <div class="range-input">
                              <el-input size="mini" :maxlength="100" v-model.trim="ruleForm.minClickNum"  @input="v => ruleForm.minClickNum = v.replace(/[^\d]/g,'')"></el-input>
                              <div class="line">-</div>
                              <el-input size="mini" :maxlength="100" v-model.trim="ruleForm.maxClickNum"  @input="v => ruleForm.maxClickNum = v.replace(/[^\d]/g,'')"></el-input>
                              </div>
                          </div>
                          <!-- 区间输入框 结尾-->
                        </div>
                        <div v-else-if="rowParams.input=='inputText'" class="filter-content">
                          <!-- 单个输入框筛选 -->
                          <div class="filter-num filter-serachTnput">
                            <el-input size="mini" :maxlength="100" v-model="inputRuleForm.keyword"></el-input>
                          </div>
                        <!-- 单个输入框 结尾-->
                      </div>
                        <div v-else-if="rowParams.input=='multTagText'" class="filter-content">
                          <!-- 单个输入框多值or筛选 -->
                          <div class="filter-num filter-serachTnput multTagText">
                            <MultiInputTag :showSearchType="false" v-model="checkList" @input="onInput"></MultiInputTag>
                          </div>
                        <!-- 单个输入框 结尾-->
                      </div>
                        <div v-else-if="rowParams.input=='select'" class="filter-content">
                          <!-- 扩展选择框 -->
                          <div class="filter-num filter-serachTnput">
                            <el-select :loading="!!rowParams.loading" :popper-append-to-body="false" popper-class="select" size="mini" style="width: 100%;" collapse-tags multiple filterable default-first-option v-model="checkList" placeholder="">
                              <el-option  v-for="item in rowParams.options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                          </div>
                        <!-- 单个输入框 结尾-->
                      </div>
                      <div v-else-if="rowParams.input=='radio'" class="filter-content">
                        <!-- 扩展单项框 -->
                        <div class="filter-num filter-serachTnput">
                          <el-radio-group v-model="checkRadio">
                            <p class="chebox-item" v-for="(item,index) in rowParams.options" :key="index">
                             <el-radio :label="item.value"> {{item.text}}</el-radio>
                            </p>
                          </el-radio-group>
                        </div>
                      <!-- 单个输入框 结尾-->
                    </div>
                    <div v-else-if="rowParams.input=='selectSingle'" class="filter-content">
                      <!-- 扩展单项框 -->
                      <div class="filter-num filter-serachTnput">
                        <el-select 
                          :popper-append-to-body="false" 
                          popper-class="select" 
                          size="mini" 
                          style="width: 100%;" 
                          filterable default-first-option v-model="checkSelectSingle" placeholder="">
                          <el-option  v-for="item in rowParams.options" :key="item.value" :label="item.text" :value="item.value"> </el-option>
                        </el-select>
                      </div>
                    <!-- 单个输入框 结尾-->
                  </div>
                        <div v-else>
                        <div class="filter-content">
                          <div class="filter-serachTnput">
                          <el-input :maxlength="100" v-model="filterValue" :placeholder="$t('message.prompt.pleaseEnter')" @input="searchEvent" @blur="searchEvent"></el-input>
                          </div>
                        
                          <div class="chekList" v-infinite-scroll="scrollLoad">
                          <el-checkbox-group v-model="checkList">
                            <template v-show="rowParams.options.length > 0">
                              <p class="chebox-item" v-for="(item,index) in rowParams.options ? rowParams.options.slice(0,showLength) : []" :key="index">
                              <el-checkbox  :label="item.value"> {{item.text}}</el-checkbox>
                              </p>
                            </template>
                          </el-checkbox-group>
                        </div>
                      </div>
                      </div>
                          <div class="footer-box" v-if="rowParams.input=='sectionText'">
                                <span class="filter"><el-link :type="ruleForm.maxClickNum&&ruleForm.minClickNum?'default':'info'" :disabled="ruleForm.maxClickNum&&ruleForm.minClickNum?false:true"  :underline="false" @click="filterData(1)">{{$i18.language('筛选')}}</el-link></span>
                                <span class="reset"><el-link :underline="false" @click="resetFilter(1)">{{$i18.language('重置')}}</el-link></span>
                            </div>
                            <div class="footer-box" v-else-if="rowParams.input=='inputText'">
                              <span class="filter"><el-link :type="inputRuleForm.keyword.trim()?'default':'info'" :disabled="inputRuleForm.keyword.trim()?false:true"  :underline="false" @click="filterData(3)">{{$i18.language('筛选')}}</el-link></span>
                              <span class="reset"><el-link :underline="false" @click="resetFilter(3)">{{$i18.language('重置')}}</el-link></span>
                          </div>
                          <div class="footer-box" v-else-if="rowParams.input=='radio'">
                            <span class="filter"><el-link :type="checkRadio!==-1?'default':'info'" :disabled="checkRadio!==-1?false:true"  :underline="false" @click="filterData(4)">{{$i18.language('筛选')}}</el-link></span>
                            <span class="reset"><el-link :underline="false" @click="resetFilter(4)">{{$i18.language('重置')}}</el-link></span>
                          </div>
                          <div class="footer-box" v-else-if="rowParams.input=='selectSingle'">
                            <span class="filter"><el-link :type="checkSelectSingle!==''?'default':'info'" :disabled="checkSelectSingle!==''?false:true"  :underline="false" @click="filterData(5)">{{$i18.language('筛选')}}</el-link></span>
                            <span class="reset"><el-link :underline="false" @click="resetFilter(5)">{{$i18.language('重置')}}</el-link></span>
                          </div>
                          <div class="footer-box" v-else>
                            <span class="filter"><el-link :type="checkList.length==0?'info':'default'" :disabled="checkList.length==0"  :underline="false" @click="filterData(2)">{{$i18.language('筛选')}}</el-link></span>
                            <span class="reset"><el-link :underline="false" @click="resetFilter(2)">{{$i18.language('重置')}}</el-link></span>
                        </div>
                          <span slot="reference" :class="!rowParams.isShowSort?'filter_margin':''">
                            <span :class="['text'].includes(rowParams.input)?(filterValue?'activeFilter':'defaultfilter'):(ruleForm.maxClickNum||ruleForm.minClickNum ||inputRuleForm.keyword ||checkList.length>0 ||checkRadio!==-1||checkSelectSingle!=='' )?'activeFilter':'defaultfilter'">
                            <svg-icon name="filter_icon" class="filterOperation"></svg-icon>
                            </span>
                          </span>
                        </el-popover>
                    </div>
                  </div>
  
                    <div>
                    </div>
      </div> 
  </template>
  
  <script>
  import MultiInputTag from '@/views/Trade/components/TradeResults/MultiInputTag'
  export default {
      components: {
        MultiInputTag,
      },
      props:{
          filterTitle:{
              type:String
          },
          filterParams:{
              type:Object,
              default:{}
          },
          rowParams:{
            type:Object,
            default:{}
          }
      },
      data() {
      return {
          filterValue:'',
          checkList:[],
          checkRadio: -1,
          checkSelectSingle: "",
          visible:false,
          ruleForm:{
          minClickNum:'',
          maxClickNum:''
          },
          inputRuleForm: {
            keyword: ""
          },
          showLength: 10
      }
     },
     watch:{
      filterValue(){
          this.searchEvent (this.filterValue)
      },
      visible(){
        this.searchEvent (this.filterValue)
      },
      // 筛选字段
      'rowParams.searchVal': {
        handler(val, oldVal) {
          this.showSearch(val)
        },
        immediate: true,
      }
     },
     mounted() {
      window.addEventListener('scroll', this.handleScroll, true)
     },
     destroyed() {
      window.removeEventListener("scroll", this.handleScroll)
     },
     methods:{
      // 监听滚动，重置popover的位置
      handleScroll() {
        this.$refs.popover&&this.$refs.popover.updatePopper()
      },
      resetFilter(type){
        if(type==1){
          this.ruleForm.minClickNum = ''
          this.ruleForm.maxClickNum = ''
          this.$emit('resetFilter',this.ruleForm,this.rowParams.key,type, this.rowParams)
        }else if(type==2){
       
         this.filterValue=''
          this.checkList=[]
          this.searchEvent(this.filterValue)
          this.$emit('resetFilter',this.checkList,this.rowParams.key,type, this.rowParams)
        } else if(type==4){
          this.filterValue=''
          this.searchEvent(this.filterValue)
          this.$emit('resetFilter',this.checkRadio,this.rowParams.key,type, this.rowParams)
        } else if(type==5) {
          this.filterValue=''
          this.checkSelectSingle = ''
          this.searchEvent(this.filterValue)
          this.$emit('resetFilter',this.checkSelectSingle,this.rowParams.key,type, this.rowParams)
        }else {
          this.inputRuleForm.keyword = ''
          this.$emit('resetFilter',this.inputRuleForm,this.rowParams.key,type,this.rowParams)
        }
        this.visible = false
      },
      // 贸易情报筛选回显到表头
      showSearch(val) {
        if(typeof(val) === 'string') {
          this.inputRuleForm.keyword = val
          if(this.rowParams.input == 'selectSingle') {
            this.checkSelectSingle = val || ""
          }
        } else if(val instanceof Array) {
          this.checkList = val
        } else if(typeof(val) === 'number') {
          this.checkRadio = val
          this.checkSelectSingle = val
        } else {
          this.inputRuleForm.keyword = ""
          this.checkList = []
        } 
      },
      filterData(type){
        if(type==1){//数字区间过滤
         if(Number(this.ruleForm.minClickNum)>Number(this.ruleForm.maxClickNum)){
          this.$message({
            type:'warning',
            message:this.$i18.language('最小值不能大于最大值，请调整后重新输入。')
          })
         }else{
          this.visible = false
          this.$emit('filterData',this.ruleForm,this.rowParams.key,type)
         }
        }else if(type==2){//多选过滤
          this.visible = false
          this.$emit('filterData',this.checkList,this.rowParams.key,type, this.rowParams)
        } else if(type==4){
          this.visible = false
          this.$emit('filterData',this.checkRadio,this.rowParams.key,type, this.rowParams)
        }else if(type==5){
          this.visible = false
          this.$emit('filterData',this.checkSelectSingle,this.rowParams.key,type, this.rowParams)
        }else {
          this.visible = false
          this.$emit('filterData',this.inputRuleForm,this.rowParams.key,type, this.rowParams)
        }
       
      },
      // 筛选项change
      filterChange(val) {
        let row = this.rowParams.options.filter(e=>val.includes(e.value))
        this.$emit('filterChange',row, val)
      },
      clearTimer() {
          if (this.timer) {
            clearTimeout(this.timer);
          }
        },
   
    searchEvent (val) {
          this.clearTimer();
          if (this.rowParams.options && this.rowParams.options.length > 0) {
          //获取当前延时函数的ID，便于后面clearTimeout清除该ID对应的延迟函数
          this.timer = setTimeout(() => {
             this.getList();
            }, 500);
          } else {
            this.getList(); //查询
          }
        },
      getList(){
        let arr =this.rowParams.options|| []
        this.$emit('filterValue',this.filterValue,arr,this.rowParams.key)
      },
      scrollLoad() {
        this.showLength += 10
      },
      onHide() {
        this.showLength = 10
      },
      //过滤排序  
      filterSort(type){
         this.$emit('sortFilterChange',type,this.filterKey)
      },
      sort(dataType,sortType){
        this.$emit('sortChange',dataType,sortType)
      },
      onInput() {
        if (this.checkList.length <= 0) {
          setTimeout(() => {
            this.resetFilter(2)
            this.visible = false
          }, 100);
        }
      },
     }
  }
  </script>
  <style>
  .my-popover{
      padding: 0 !important;
    }
  </style>
  <style lang="scss" scoped>
    
   .filter-sort{
       display: inline-block;
        .filter-sort-box{
          display: flex;
          flex: 1;
          flex-direction: row;
          justify-content: center;
          align-items: center;
        
        }
       .filter-title{
        
       }
       .sort-box{
        .sort-icon{
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          height: 34px;
          width: 24px;
          vertical-align: middle;
          cursor: pointer;
          overflow: initial;
          position: relative;
          .sort-caret{
            width: 0;
            height: 0;
            border: 5px solid transparent;
            position: absolute;
            left: 7px;
            font-size: 15px;
          }
          .ascending {
              border-bottom-color: #c0c4cc;
              top: 5px;
          }
          .descending {
            border-top-color: #c0c4cc;
          }
          .ascActive{
              border-bottom-color:#409eff;
            }
          .descActive{
           border-top-color:#409eff;
          }
        }
       }

      
    }
  
    .filter-serachTnput{
    // width: 200px;
    margin-bottom: 10px;
    /deep/.el-input--medium .el-input__inner{
      height: 25px !important;
    }
  }
  .chekList{
    min-width: 137px;
    max-height: 230px;
    overflow-y: scroll;
  }
  .chekList::-webkit-scrollbar {/*滚动条整体样式*/
          width: 6px;     /*高宽分别对应横竖滚动条的尺寸*/
          height: 1px;
      }
      .chekList::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
          border-radius: 10px;
          background: #E5E5E5;
      }
  .chebox-item{
          margin-top: 5px;
          margin-bottom:5px;
        }
  .footer-box{
          height: 30px;
          line-height: 30px;
          // margin-top: 10px;
          border-top: 1px solid #d8dee6;
          span{
            font-size: 13px;
            margin-left: 5px;
          }
          .filter{
            margin-left: 10px;
          }
          .reset{
             margin-left: 5px;
          }
  }
  .filter-content{
    padding: 12px 12px 0 12px;
  }
  .icon-blue{
    color:$--color-primary-6;
  }
  .icon-default{
    color:#C0C4CC;
  }
  .active{
    color: #1890ff;
  }
  .activeFilter{
    .svg-icon{
      fill: #1890ff;
    }
  }
  .defaultfilter{
    .svg-icon{
      fill:#C0C4CC;
    }
  }
  .filterOperation{
    font-size: 13px;
  }
  
  .filter_margin{
    margin-left: 5px;
  }
  .filter-num{
    box-sizing: border-box;
    margin-bottom: 10px;
  }
  .range-input {
            display: flex;
            /deep/.el-input {
              height: 25px;
              .el-input__inner {
                border-color: $--color-border;
                height: 25px;
              }
              &:first-of-type {
                .el-input__inner {
                  border-right: none !important;
                  border-radius: 4px 0 0 4px !important;
                }
              }
              &:last-of-type {
                .el-input__inner {
                  border-left: none !important;
                  border-radius: 0 4px 4px 0 !important;
                }
              }
            }
            .line {
              font-weight: 700;
              color: $--color-dark-default;
              box-sizing: border-box;
              border-top: 1px solid $--color-border;
              border-bottom: 1px solid $--color-border;
            }
          }
  
  </style>
  